export default "__VITE_PUBLIC_ASSET__a249f0aa__"